
export const personalInfo = {
  name: "Muhammad Asif",
  title: "MERN Stack Developer",
  email: "asifhere121@gmail.com",
  phone: "+923086233741",
  location: "Islamabad, Pakistan",
  linkedin: "https://www.linkedin.com/in/muhammad-asif-4732531bb/",
  github: "https://github.com/asifhere4466",
  summary: "Experienced MERN Stack Developer with a proven track record in designing, developing, and maintaining web-based systems across diverse domains including e-commerce, education, finance, hospitality, and logistics. Passionate about building responsive, scalable applications and delivering exceptional user experiences."
};

export const skills = {
  frontend: [
    { name: "React.js", level: "Advanced" },
    { name: "Next.js", level: "Advanced" },
    { name: "HTML5", level: "Expert" },
    { name: "CSS3", level: "Expert" },
    { name: "JavaScript", level: "Advanced" },
    { name: "TypeScript", level: "Intermediate" },
    { name: "Tailwind CSS", level: "Advanced" },
    { name: "Responsive Design", level: "Expert" }
  ],
  backend: [
    { name: "Node.js", level: "Advanced" },
    { name: "Express.js", level: "Advanced" },
    { name: "RESTful APIs", level: "Advanced" },
    { name: "AWS Services", level: "Intermediate" },
    { name: "Supabase", level: "Advanced" },
    { name: "Authentication & Authorization", level: "Advanced" }
  ],
  databases: [
    { name: "MongoDB", level: "Advanced" },
    { name: "MySQL", level: "Intermediate" },
    { name: "AWS DynamoDB", level: "Intermediate" },
    { name: "Supabase", level: "Advanced" },
    { name: "Database Design", level: "Advanced" }
  ],
  tools: [
    { name: "Git & GitHub", level: "Advanced" },
    { name: "Vercel", level: "Advanced" },
    { name: "AWS Services", level: "Intermediate" },
    { name: "WordPress", level: "Intermediate" },
    { name: "Postman", level: "Advanced" },
    { name: "VS Code", level: "Expert" }
  ]
};

export const experience = [
  {
    id: 1,
    title: "MERN Stack Developer",
    company: "The Revolution Technologies",
    location: "Rawalpindi",
    duration: "July 2024 - Present",
    responsibilities: [
      "Contributed to the design, development, and maintenance of multiple web-based systems across e-commerce, education, finance, hospitality, and logistics domains",
      "Built responsive and scalable front-end applications using React.js and Next.js with optimized performance and smooth UX",
      "Developed and maintained RESTful APIs with Node.js and Express.js, implementing authentication, role-based access control, and complex business logic",
      "Designed and managed databases (MongoDB, MySQL, Supabase, AWS DynamoDB) ensuring efficient data modeling and query performance",
      "Integrated cloud services on AWS for deployment, database management, and environment configuration",
      "Utilized JavaScript and TypeScript to create maintainable and scalable codebases",
      "Assisted with WordPress tasks including customization and content updates"
    ]
  }
];

export const projects = [
  {
    id: 1,
    name: "KidsPro - School Management Platform",
    description: "A comprehensive school management system built with Next.js and Supabase, enabling administrators and teachers to efficiently manage students, classes, attendance, and academic records. Features secure authentication, role-based access control, and real-time data synchronization.",
    technologies: ["Next.js", "Supabase", "React", "TypeScript", "Tailwind CSS", "Vercel"],
    image: "/assets/images/kidspro.png",
    features: ["Student & Teacher Management", "Attendance Tracking System", "Academic Records & Reports", "Role-based Access Control", "Real-time Updates"],
    url: "https://kidspro-system-y74h.vercel.app/",
    category: "Education"
  },
  {
    id: 2,
    name: "MesobStore - E-commerce Platform",
    description: "Full-stack e-commerce solution with a modern customer-facing storefront and comprehensive admin panel. Features include product catalog management, shopping cart, secure payment processing, order tracking, and inventory management with real-time updates.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "AWS", "JWT Authentication"],
    image: "/assets/images/mesob.png",
    features: ["Product Catalog & Search", "Shopping Cart & Checkout", "Order Management System", "Admin Dashboard", "User Authentication", "Inventory Tracking"],
    url: "https://mesobstore.com/",
    category: "E-commerce"
  },
  {
    id: 3,
    name: "MesobFinancial - Financial Management System",
    description: "Enterprise-grade financial management dashboard for tracking transactions, generating reports, and managing financial records. Built with React and AWS DynamoDB for scalable NoSQL data storage and optimal performance.",
    technologies: ["React", "AWS DynamoDB", "Node.js", "Express.js", "AWS Services", "Chart.js"],
    image: "/assets/images/mesobfinancial.png",
    features: ["Transaction Management", "Financial Reports & Analytics", "Interactive Dashboard", "Data Visualization", "Real-time Updates", "Export Functionality"],
    url: "https://app.mesobfinancial.com/",
    category: "Finance"
  },
  {
    id: 4,
    name: "Envoy Hotel - Hotel Booking System",
    description: "Responsive hotel booking platform that enables users to browse available rooms, check real-time availability, and complete seamless booking workflows. Features include room filtering, date selection, booking confirmation, and reservation management.",
    technologies: ["React", "Node.js", "Express.js", "MySQL", "JWT", "Responsive Design"],
    image: "/assets/images/envoy.png",
    features: ["Room Browsing & Filtering", "Real-time Availability", "Booking System", "Reservation Management", "User Dashboard", "Email Notifications"],
    url: "https://envoyhotel.com/",
    category: "Hospitality"
  },
  {
    id: 5,
    name: "Shipping Line - Logistics & Fleet Platform",
    description: "Enterprise logistics platform with role-based dashboards, shipment lifecycle management, vehicle tracking, invoicing, reporting, and master-data driven configuration for shipping lines.",
    technologies: ["Next.js", "TypeScript", "NextAuth", "NextUI", "MongoDB Atlas", "Node.js APIs", "Cron Jobs", "Admin Panel", "Role-Based Access", "Reporting"],
    image: "/assets/images/shipping.png",
    features: ["Role-based Dashboards & Permissions", "Shipment & Vehicle Lifecycle Tracking", "Invoices & Rate Management", "Master Data Configuration", "PNL & Operational Reports", "Automations via Cron Jobs"],
    url: "",
    category: "Logistics"
  }
];

export const education = [
  {
    id: 1,
    degree: "Bachelor of Science in Computer Science",
    university: "University of Education",
    location: "Faisalabad",
    duration: "2020 - 2024",
    status: "Completed"
  }
];